import { Outlet, useParams } from 'react-router-dom'

import { CustomResourcesSettingsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/custom_resources/lib/SettingsCollectionsBootstrap'

const Container = () => {
  const { id } = useParams()
  const schemaId = String(id)

  const { data, loading } = useQuery(CustomResourcesSettingsRootPageDocument)
  const canManage = data?.apiCore._policies.companyManageCustomization.can ?? false

  if (loading) return <Loading />

  return (
    <AuthorizeUser authorizeFn={() => canManage && !loading}>
      <Outlet
        context={{
          schemaId,
        }}
      />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
